var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { helper } from "../../common/helper";

//http://localhost:8080/sport/news/a/1765476.html?_x_preview=1
var RTLSportCompetitionTeamOverview = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportCompetitionTeamOverview, _LitElement);
  function RTLSportCompetitionTeamOverview() {
    _classCallCheck(this, RTLSportCompetitionTeamOverview);
    return _callSuper(this, RTLSportCompetitionTeamOverview);
  }
  _createClass(RTLSportCompetitionTeamOverview, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportCompetitionTeamOverview.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this = this;
      fetch(`https://api-gate.rtl.lu/sport/sports/${this.sport}/competitions/${this.competition}/teams`).then(function (resp) {
        return resp.json();
      }).then(function (r) {
        return _this.teams = r;
      });
      fetch(`https://api-gate.rtl.lu/sport/sports/${this.sport}/competitions/${this.competition}`).then(function (resp) {
        return resp.json();
      }).then(function (r) {
        return _this._competition = r;
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this._competition) return;
      return html(_t || (_t = _`
        <style>
            .team-images-container {
                height:60px;
                overflow-x: scroll;
                white-space: nowrap;
            }

            .team-images-container > a > img {
                border-bottom:2px solid white;
                opacity: .8;
            }

            .team-images-container > a > img:hover {
                border-bottom:2px solid red;
                opacity: 1;
            }
        </style>
            <h2>${0}</h2>
            <div class="team-images-container">
                ${0}
            </div>
        `), this._competition.name, this.teams.map(function (team) {
        return html(_t2 || (_t2 = _`
                    <a href="https://www.rtl.lu/sport/futtball/resultater/national"><img src=${0} height="50"/></a>
                    `), team.logo_url);
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        competition: {
          type: String
        },
        _competition: {
          type: Object
        },
        sport: {
          type: String
        },
        teams: {
          type: Array
        }
      };
    }
  }]);
  return RTLSportCompetitionTeamOverview;
}(LitElement);
export { RTLSportCompetitionTeamOverview as default };
window.customElements.define('rtl-sport-competition-team-overview', RTLSportCompetitionTeamOverview);